// 業務管理アシスタントの SSE クライアント。backend: bizhub/views/assistant_views.py
import { getApiBaseUrl, getAuthToken } from "./fetchApi";
import { useBizhubStore } from "@/stores/bizhubStore";

export async function sendBizhubAssistantMessage({ conversationId, message, context }, handlers) {
  const { onConversation, onToken, onToolCall, onToolResult, onOpenScreen, onDone, onError } = handlers;
  const store = useBizhubStore();
  let idToken;
  try {
    idToken = await getAuthToken();
  } catch (e) {
    onError("ログインが必要です");
    return;
  }
  try {
    const response = await fetch(`${getApiBaseUrl()}/bizhub/assistant/`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
        ...(store.staffId ? { "X-Bizhub-Staff": String(store.staffId) } : {}),
      },
      body: JSON.stringify({ conversation_id: conversationId || null, message, context }),
      credentials: "include",
    });
    if (!response.ok) {
      let msg = "リクエストに失敗しました";
      try {
        const err = await response.json();
        msg = err.message?.[0] || err.staff?.[0] || err.conversation_id?.[0] || err.detail || err.error || msg;
      } catch (_) { /* non-JSON */ }
      onError(msg);
      return;
    }
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n");
      buffer = lines.pop();
      for (const line of lines) {
        if (!line.startsWith("data: ")) continue;
        let data;
        try { data = JSON.parse(line.slice(6)); } catch (_) { continue; }
        if (data.type === "conversation") onConversation?.(data.id);
        else if (data.type === "token") onToken(data.content);
        else if (data.type === "tool_call") onToolCall?.(data.name);
        else if (data.type === "tool_result") onToolResult?.(data);
        else if (data.type === "open_screen") onOpenScreen?.(data);
        else if (data.type === "done") onDone(data);
        else if (data.type === "error") onError(data.error);
      }
    }
  } catch (error) {
    onError(error.message || String(error));
  }
}
